<div class="modal-header">
  <h4 class="modal-title pull-left"> Confirm Cancel Report </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Reason</label>
      <textarea class="form-control rounded-0" rows="2" name="REASON" [(ngModel)]="reason" required></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" [disabled]="!reason" (click)="onConfirm()">
    Accept
  </button>
</div>
